<template>
  <div>
    <section style="margin-bottom: 50px">
      <b-container class="container">
        <b-row>
          <b-col md="12">
            <ul class="timeline list-style-none">
              <li>
                <div class="timeline-badge"><h4>01</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Reporte de Vehículo</h5>
                  </div>
                  <div class="timeline-body">
                    <p>
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Asesor</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-badge"><h4>02</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Cotizacion</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button variant="dark" class="shadow" block>
                          <i class="fas fa-file-pdf"></i>
                          Ver Cotizacion
                        </b-button>
                      </b-col>
                    </b-row>

                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Avaluato</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Asesor</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge"><h4>03</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">
                      Plan de Comercializacion
                    </h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button variant="dark" class="shadow" block>
                          <i class="fas fa-hand-holding-usd"></i>
                          Gestionar Pagos
                        </b-button>
                      </b-col>
                    </b-row>

                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Asesor</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>

              <li class="timeline-inverted">
                <div class="timeline-badge"><h4>04</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Factura</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button variant="dark" class="shadow" block>
                          <i class="fas fa-file-pdf"></i>
                          Ver Factura
                        </b-button>
                      </b-col>
                    </b-row>
                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Operador Brockar</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge"><h4>05</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Inspección Legal</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center ">
                      <strong><span class="text-span-2">Estado: </span></strong>
                      <strong
                        ><span class="text-span-2 ml-2"
                          ><i class="fas fa-check-circle"></i> Aprobado</span
                        ></strong
                      >
                    </b-row>
                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Operador Brockar</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-badge"><h4>06</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Inspección Mecánica</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button
                          variant="dark"
                          class="shadow"
                          block
                          @click="modalshow = !modalshow"
                        >
                          <i class="fas fa-calendar-day"></i>
                          Agendar Cita
                        </b-button>
                        <b-modal size="xl" v-model="modalshow">
                          <!--<modalDetalleAgendar />-->
                        </b-modal>
                      </b-col>
                    </b-row>

                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Perito</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge"><h4>07</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Inspección Mecánica</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button variant="dark" class="shadow" block>
                          <i class="fas fa-file-pdf"></i>
                          Ver Inspeccion
                        </b-button>
                      </b-col>
                    </b-row>
                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Perito</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-badge"><h4>08</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Gastos de Traspaso</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row align-h="center " cols="12">
                      <b-col lg="7" md="7" sm="12">
                        <b-button variant="dark" class="shadow" block>
                          <i class="fas fa-file-pdf"></i>
                          Ver Soporte
                        </b-button>
                      </b-col>
                    </b-row>
                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Asesor</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge"><h4>09</h4></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h5 style="text-transform: none">Mercadeo</h5>
                  </div>
                  <div class="timeline-body">
                    <b-row class="12">
                      <b-col style="padding: 0">
                        <img
                          style="padding: 0"
                          src="https://via.placeholder.com/42x48.png"
                          alt=""
                        />
                      </b-col>
                      <b-col style="padding: 0">
                        <img
                          src="https://via.placeholder.com/42x48.png"
                          alt=""
                        />
                      </b-col>
                      <b-col style="padding: 0">
                        <img
                          src="https://via.placeholder.com/42x48.png"
                          alt=""
                        />
                      </b-col>
                      <b-col style="padding: 0">
                        <img
                          src="https://via.placeholder.com/42x48.png"
                          alt=""
                        />
                      </b-col>
                      <b-col style="padding: 0">
                        <img
                          src="https://via.placeholder.com/42x48.png"
                          alt=""
                        />
                      </b-col>
                      <b-col style="padding: 0">
                        <i class="fab fa-instagram fa-3x"></i>
                      </b-col>
                      <b-col style="padding: 0">
                        <i class="fab fa-facebook-square fa-3x"></i>
                      </b-col>
                    </b-row>
                    <p style="margin-top: 20px">
                      <span> dd/mm/yy </span>
                      <i class="fas fa-building" style="margin-left: 10px"></i>
                      <span>Brockar</span>
                      <i class="fas fa-user" style="margin-left: 10px"></i>
                      <span>Asesor</span>
                      <i class="fas fa-phone-alt" style="margin-left: 10px"></i>
                      <span>Contacto</span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<style>
span.text-span-2 {
  font-size: 1.25rem;
  color: #363636;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 25%);
}
</style>
<script>
//import modalDetalleAgendar from "modules/frontend/detalle/modalDetalleAgendar";
export default {
  components: {
    //modalDetalleAgendar,
  },
  data() {
    return {
      modalshow: false,
      linetime: [
        {
          titleline: "Entrega de documentos a tramitador",
          numline: 1,
          empresa: "Empresa",
          user: "Usuario",
          cel: "contacto",
          fecha: "05/10/2020",
        },
        {
          titleline: "Entrega de documentos a tramitador",
          numline: 2,
          empresa: "Empresa",
          user: "Usuario",
          cel: "contacto",
          fecha: "05/10/2020",
        },
        {
          titleline: "Entrega de documentos a tramitador",
          numline: 2,
          empresa: "Empresa",
          user: "Usuario",
          cel: "contacto",
          fecha: "05/10/2020",
        },
        {
          titleline: "Entrega de documentos a tramitador",
          numline: 2,
          empresa: "Empresa",
          user: "Usuario",
          cel: "contacto",
          fecha: "05/10/2020",
        },
      ],
      newtimeline: [],
    };
  },
  beforeMount() {
    let aux = false;

    for (let i = 0; i < this.linetime.length; i++) {
      if (aux == false) {
        this.newtimeline.push({
          title: this.linetime[i].titleline,
          numline: i + 1,
          empresa: this.linetime[i].empresa,
          user: this.linetime[i].user,
          cel: this.linetime[i].cel,
          fecha: this.linetime[i].fecha,
          position: "",
        });
        aux = true;
      } else {
        this.newtimeline.push({
          title: this.linetime[i].titleline,
          numline: i + 1,
          empresa: this.linetime[i].empresa,
          user: this.linetime[i].user,
          cel: this.linetime[i].cel,
          fecha: this.linetime[i].fecha,
          position: "timeline-inverted",
        });
        aux = false;
      }
    }

  },
};
</script>